module.exports = __webpack_public_path__ + "static/media/service-img02.f5fe7458.png";